import React from "react";

const Error404 = () => {
  return <h1 className="mt-5 text-center">404</h1>;
};

export default Error404;
